/* eslint-disable react/jsx-closing-tag-location */
import { Button, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { CurrencyDollarIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { hasRole } from "../../services/wp.user.service";
import { useAuth } from "../../services/wp.auth.service";

import Logo from "../Logo";
import NavLink from "./NavLink";

import { ReactComponent as LwcIcon } from "../../assets/images/lwc-tm-logo.svg";

import loggedInMenu from "./LoggedInMenu.json";
import mainMenu from "./mainMenu.json";
import topBarMenu from "./topBarMenu.json";

const navLinkClassNames = "text-white fw-bold text-center py-3 d-block";

const NavigationOffcanvas = ({
	id,
	show,
	toggleShow
}) => {
	const { user, logout } = useAuth();

	return (
		<Navbar.Offcanvas
			aria-labelledby="offcanvasNavbarLabel"
			className="bg-darkblue text-white"
			id={id}
			onHide={toggleShow}
			placement="end"
			show={show}
		>
			<Offcanvas.Header className="bg-darkerblue color-white text-white" closeButton>
				<Logo style={{ height: "40px" }} />
			</Offcanvas.Header>

			<Offcanvas.Body className="p-0 d-flex flex-column">
				<div className="p-3">
					<Nav className="bg-darkerblue rounded-2 text-center mb-3">
						{ !!user && loggedInMenu.map((item) => (
							<NavLink
								className={navLinkClassNames}
								key={item.to}
								onClick={toggleShow}
								to={item.to}
							>
								{item.text}
							</NavLink>
						)) }

						{ hasRole("facilitator") ? (
							<>
								<NavLink
									className={`${navLinkClassNames} border-top border-darkblue`}
									onClick={toggleShow}
									to="/facilitator"
								>
									Facilitator Dashboard
								</NavLink>
								<NavLink
									className={`${navLinkClassNames}`}
									onClick={toggleShow}
									to="/facilitator/future-events"
								>
									My Upcoming Classes
								</NavLink>
							</>
						) : null}

						{ hasRole("administrator") ? (
							<NavLink
								className={`${navLinkClassNames} border-top border-darkblue`}
								onClick={toggleShow}
								to="/admin"
							>
								Admin
							</NavLink>
						) : null}

						{ user
							? (
								<Nav.Item
									className={`${navLinkClassNames} border-top border-darkblue`}
									onClick={logout}
								>
									Logout
								</Nav.Item>
							)
							: (
								<NavLink
									className={navLinkClassNames}
									onClick={toggleShow}
									to="/login"
								>
									Login
								</NavLink>)}
					</Nav>

					<Button className="d-block w-100" variant="lightblue">
						<CurrencyDollarIcon className="i me-2" />
						Donate
					</Button>
				</div>

				<div className="p-3 bg-primary">
					<Nav className="justify-content-end flex-grow-1 pe-3">
						{mainMenu.map((item) => (
							<NavLink
								className={navLinkClassNames}
								href={item.href}
								key={item.slug}
								onClick={toggleShow}
								to={item.to}
							>
								{item.name}
							</NavLink>
						))}
					</Nav>
				</div>
				<div className="p-3 flex-fill d-flex flex-column">
					<Nav className="justify-content-end flex-grow-1 d-flex flex-column pe-3 flex-fill">
						{topBarMenu.map((item) => (
							<NavLink
								className={navLinkClassNames}
								href={item.href}
								key={item.slug}
								onClick={toggleShow}
								to={item.to}
							>
								{item.name}
							</NavLink>
						))}
						<div className="flex-fill" />
						<Navbar.Brand as={Link} className="text-center" to="/">
							<LwcIcon />
						</Navbar.Brand>
					</Nav>
				</div>
			</Offcanvas.Body>
		</Navbar.Offcanvas>
	);
};

NavigationOffcanvas.propTypes = {
	id: PropTypes.string,
	show: PropTypes.bool,
	toggleShow: PropTypes.func
};

NavigationOffcanvas.defaultProps = {
	id: "",
	show: false,
	toggleShow: null
};

export default NavigationOffcanvas;
